import {Injectable} from '@angular/core';
import {UserModel} from '../@models/user.model';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly _key = 'dposPosUser';

  constructor(private router: Router) {}

  saveUser(user: UserModel) {
    localStorage.setItem(this._key, JSON.stringify(user));
    localStorage.setItem('dposPosLastLoginDate', JSON.stringify(new Date()));
  }

  getUser(): UserModel {
    let userJson = localStorage.getItem(this._key);
    let userModel = JSON.parse(userJson) as UserModel;
    return userModel;
  }

  logout(){
    localStorage.removeItem('dposPosMerchant');
    localStorage.removeItem('dposPosUserShift');
    localStorage.removeItem('dposPosLastLoginDate');
    localStorage.removeItem('dposPosUser');
    localStorage.removeItem('dposPosUserShiftUpdateDate');

    this.router.navigate(['/login']);
  }

  getLastLoginDate(): Date {
    const logindate = localStorage.getItem('dposPosLastLoginDate');
    return logindate ? new Date(JSON.parse(logindate)) : null;
  }
}
